import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { AddScheduleHourData } from '../../schedule-hours/models/schedule-hours.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-add-schedule-hour-view',
    styleUrls: ['./add-schedule-hour-view.component.scss'],
    templateUrl: './add-schedule-hour-view.component.html',
    standalone: false
})
export class AddScheduleHourViewComponent {
   @Input() callState: CallState;

   @Input() form: UntypedFormGroup;

   @Input() title: string;

   @Input() isAdd: boolean;

   @Output() formSubmitted = new EventEmitter<AddScheduleHourData>();

   @Output() formCanceled = new EventEmitter<void>();

   daysOfWeekArray = [
      { name: 'Mo', value: 'Monday' },
      { name: 'Tu', value: 'Tuesday' },
      { name: 'We', value: 'Wednesday' },
      { name: 'Th', value: 'Thursday' },
      { name: 'Fr', value: 'Friday' },
      { name: 'Sa', value: 'Saturday' },
      { name: 'Su', value: 'Sunday' },
   ];

   selectedDays: string[] = [];

   onCheckboxChange(item: string) {
      if (this.selectedDays.includes(item)) {
         this.selectedDays = this.selectedDays.filter((selectedDay) => {
            return selectedDay !== item;
         });
      } else {
         this.selectedDays.push(item);
      }
      this.form.patchValue({ selectedDays: this.selectedDays });
   }

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      } else {
         this.form.markAllAsTouched();
      }
   }

   isSafari() {
      return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
   }
}
